// extracted by mini-css-extract-plugin
module.exports = {"menu":"Nav_menu__6qBwT","list":"Nav_list__3DDQO","item":"Nav_item__2sH5g","active":"Nav_active__3Dz94"};